import {ConfigKeys} from '../@types/services/Config/ConfigKeys';
import app from './app';
import {IConfig} from '@src/@interfaces/services/Config/IConfig';

export function config(): IConfig;
export function config(key: ConfigKeys, defaultValue?: any): any;
export function config(key?: ConfigKeys, defaultValue?: any): (typeof key) extends undefined ? IConfig : any {
    const config = app('config');

    return key != null ? config.get(key, defaultValue) : config;
}

export default config;
